<template>
  <TopBar />
  <Aside />
  <Content />
</template>

<script>
import TopBar from '../components/TopBar.vue'
import Aside from '../components/Aside.vue'
import Content from '../components/UserArea/Content.vue'

export default {
  name: 'Accounts',
  data() {
    return {
      
    }
  },
  components: {
    TopBar, Aside, Content
  },
  methods: {
    
  }
}
</script>

<style scoped>

  #app {
    height: 100vh;
  }

</style>

